"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Option = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("..");

var _Dropdown = require("./Dropdown.style");

var Option = function Option(_ref) {
  var data = _ref.data,
      innerProps = _ref.innerProps,
      isDisabled = _ref.isDisabled;
  var avatarProps = data.avatarProps,
      iconProps = data.iconProps,
      label = data.label,
      email = data.email,
      description = data.description;
  return /*#__PURE__*/_react["default"].createElement(_Dropdown.StyledOption, (0, _extends2["default"])({}, innerProps, {
    isDisabled: isDisabled
  }), (avatarProps || iconProps) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "eui-dd-icon"
  }, iconProps && /*#__PURE__*/_react["default"].createElement(_.Icon, (0, _extends2["default"])({
    size: 16
  }, iconProps))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "eui-dd-desc"
  }, label && /*#__PURE__*/_react["default"].createElement("span", {
    className: "eui-dd-opt-label"
  }, label), email && /*#__PURE__*/_react["default"].createElement("span", {
    className: "eui-dd-opt-email"
  }, email), description && /*#__PURE__*/_react["default"].createElement("span", {
    className: "eui-dd-opt-description"
  }, description)));
};

exports.Option = Option;
Option.propTypes = {
  avatarProps: _propTypes["default"].object,
  iconProps: _propTypes["default"].object,
  label: _propTypes["default"].string,
  email: _propTypes["default"].string,
  description: _propTypes["default"].string,
  data: _propTypes["default"].object,
  selectOption: _propTypes["default"].func,
  setValue: _propTypes["default"].func,
  isDisabled: _propTypes["default"].bool,
  innerProps: _propTypes["default"].object,
  selectProps: _propTypes["default"].shape({
    isMulti: _propTypes["default"].bool
  })
};